import { actions } from './actions';
import { Country, State } from '../..//Definitions/CountryState';
import apiFetch from '@wordpress/api-fetch';

export const resolvers = {
    getCountries: () => async ({ dispatch }) => { {
        const path = '/dokan/v1/data/countries';
        const countries: Country[] = await apiFetch( { path } );
        dispatch.setCountries( countries );
        }
    },

    getCountryStates: ( countryCode: string ) => async ({ dispatch }) => { {
        if ( ! countryCode ) return;

        const path = `/dokan/v1/data/countries/${ countryCode }`;
        const data: { states: State[] }  = await apiFetch( { path } );
        dispatch.setStatesForCountry( countryCode, data.states || [] );
        }
    },
};
